import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UserDetail } from '../../models/user-detail';
import { StoreService } from '../../services/store-service/store.service';
import { UserService } from '../../services/user-service/user.service';

@Component({
   standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  constructor(
    private userService: UserService,
    public storeService: StoreService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.userService.getUserDetail();
  }
}

